import React from 'react';

// Container padrão das entregas ricas dentro da conversa.
// Mais elaborado que uma mensagem comum, mas sempre parte do fluxo.
export default function GphRichBlock({ eyebrow, title, subtitle, children, footer, tone = 'default' }) {
  return (
    <section className={`gph-rich-block gph-rich-block--${tone}`}>
      {(eyebrow || title) && (
        <header className="gph-rich-block__header">
          {eyebrow && <span className="gph-rich-block__eyebrow">{eyebrow}</span>}
          {title && <h3 className="gph-rich-block__title">{title}</h3>}
          {subtitle && <p className="gph-rich-block__subtitle">{subtitle}</p>}
        </header>
      )}
      <div className="gph-rich-block__body">{children}</div>
      {footer && <footer className="gph-rich-block__footer">{footer}</footer>}
    </section>
  );
}
